var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"StockNewsPanel"},_vm._l((_vm.news),function(n,index){return _c('StockNews',{key:index,attrs:{"news":n}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }